module.exports = __webpack_public_path__ + "img/cover_photo.a924c0f1.jpg";